/**
 * @flow
 * @relayHash 85fb291532f1620d14b4d15223a496b2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type commentForm_document$ref = any;
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type OverridePolicyQueryVariables = {|
  documentPk: number
|};
export type OverridePolicyQueryResponse = {|
  +documentOverride: ?{|
    +document: ?{|
      +id: string,
      +pk: ?number,
      +name: string,
      +status: ?DocumentStatus,
      +actions: ?$ReadOnlyArray<?{|
        +id: string,
        +pk: ?number,
        +actionType: string,
        +actionDate: any,
        +comment: string,
        +canEdit: ?boolean,
        +isExternal: boolean,
        +user: ?{|
          +id: string,
          +userDisplay: ?string,
        |},
      |}>,
      +epAssociationDocuments: ?$ReadOnlyArray<?{|
        +pk: ?number
      |}>,
      +systemDocumentTemplate: ?{|
        +pk: ?number
      |},
      +$fragmentRefs: commentForm_document$ref,
    |},
    +editForm: ?{|
      +name: ?string,
      +author: ?{|
        +pk: ?number,
        +firstName: string,
        +lastName: string,
        +title: ?string,
      |},
      +category: ?{|
        +pk: ?number,
        +name: string,
      |},
      +categoryChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +flowTemplate: ?{|
        +pk: ?number,
        +name: ?string,
      |},
      +flowTemplateChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: ?string,
      |}>,
      +bloc: ?{|
        +pk: ?number,
        +name: string,
      |},
      +blocChoices: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +html: ?string,
      +activeLifespan: ?number,
      +expirationDate: ?string,
      +isAForm: ?boolean,
      +restricted: ?boolean,
      +legacyEffectiveDate: ?string,
      +approvalDate: ?string,
      +regulations: ?$ReadOnlyArray<?number>,
      +onesourceDocuments: ?$ReadOnlyArray<?{|
        +oneSourceDocumentId: string,
        +catalogNumber: ?string,
        +manufacturerName: ?string,
        +viewUrl: ?string,
        +revisionInformation: string,
      |}>,
    |},
    +tagForm: ?{|
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>
    |},
    +scheduledEffectiveDateForm: ?{|
      +effectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +effectiveDateAlgorithm: ?string,
      +originationDate: ?string,
    |},
    +preimportRevisionForm: ?{|
      +revisionDates: ?$ReadOnlyArray<?string>
    |},
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
    +tenantsToRedirect: ?$ReadOnlyArray<?{|
      +name: string,
      +url: ?string,
    |}>,
    +rtlSupport: ?boolean,
    +newCkeditor: ?boolean,
    +ckeditor5: ?boolean,
    +redirectUrl: ?string,
    +policyActions: ?any,
  |}
|};
export type OverridePolicyQuery = {|
  variables: OverridePolicyQueryVariables,
  response: OverridePolicyQueryResponse,
|};
*/


/*
query OverridePolicyQuery(
  $documentPk: Int!
) {
  documentOverride(pk: $documentPk) {
    document {
      ...commentForm_document
      id
      pk
      name
      status
      actions(isEditPage: false) {
        id
        pk
        actionType
        actionDate
        comment
        canEdit
        isExternal
        user {
          id
          userDisplay(userDisplayType: FORWARD)
        }
      }
      epAssociationDocuments {
        pk
        id
      }
      systemDocumentTemplate {
        pk
        id
      }
    }
    editForm {
      name
      author {
        pk
        firstName
        lastName
        title
        id
      }
      category {
        pk
        name
        id
      }
      categoryChoices {
        pk
        name
        id
      }
      flowTemplate {
        pk
        name
        id
      }
      flowTemplateChoices {
        pk
        name
        id
      }
      bloc {
        pk
        name
        id
      }
      blocChoices {
        pk
        name
        id
      }
      html
      activeLifespan
      expirationDate
      isAForm
      restricted
      legacyEffectiveDate
      approvalDate
      regulations
      onesourceDocuments {
        oneSourceDocumentId
        catalogNumber
        manufacturerName
        viewUrl
        revisionInformation
        id
      }
    }
    tagForm {
      tags {
        pk
        name
        id
      }
    }
    scheduledEffectiveDateForm {
      effectiveDate
      effectiveDateTimedelta
      effectiveDateAlgorithm
      originationDate
    }
    preimportRevisionForm {
      revisionDates
    }
    error {
      statusCode
      message
    }
    tenantsToRedirect {
      name
      url
      id
    }
    rtlSupport
    newCkeditor
    ckeditor5
    redirectUrl
    policyActions
  }
}

fragment commentForm_document on DocumentType {
  id
  pk
  canComment
  subscribedToComments
  usersNotificationComment {
    usersNotificationCommentOn {
      pk
      firstName
      lastName
      id
    }
    usersNotificationCommentOff {
      pk
      firstName
      lastName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "documentPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pk",
    "variableName": "documentPk",
    "type": "Int!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "actions",
  "storageKey": "actions(isEditPage:false)",
  "args": [
    {
      "kind": "Literal",
      "name": "isEditPage",
      "value": false,
      "type": "Boolean"
    }
  ],
  "concreteType": "DocumentActionType",
  "plural": true,
  "selections": [
    v2,
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "actionDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "comment",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canEdit",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isExternal",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "UserType",
      "plural": false,
      "selections": [
        v2,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "userDisplay",
          "args": [
            {
              "kind": "Literal",
              "name": "userDisplayType",
              "value": "FORWARD",
              "type": "UserDisplayType"
            }
          ],
          "storageKey": "userDisplay(userDisplayType:\"FORWARD\")"
        }
      ]
    }
  ]
},
v7 = [
  v3
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v11 = [
  v3,
  v4
],
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "html",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "activeLifespan",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isAForm",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "regulations",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "oneSourceDocumentId",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "catalogNumber",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "manufacturerName",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewUrl",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionInformation",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "scheduledEffectiveDateForm",
  "storageKey": null,
  "args": null,
  "concreteType": "OverrideScheduledEffectiveDateForm",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateTimedelta",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "effectiveDateAlgorithm",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "originationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preimportRevisionForm",
  "storageKey": null,
  "args": null,
  "concreteType": "PreimportRevisionDatesFormType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "revisionDates",
      "args": null,
      "storageKey": null
    }
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rtlSupport",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "newCkeditor",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ckeditor5",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "policyActions",
  "args": null,
  "storageKey": null
},
v34 = [
  v3,
  v8,
  v9,
  v2
],
v35 = [
  v3,
  v2
],
v36 = [
  v3,
  v4,
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "OverridePolicyQuery",
  "id": "ec15916a389e3722c2b405b3b0e37701",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OverridePolicyQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentOverride",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentOverrideType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "commentForm_document",
                "args": null
              },
              v2,
              v3,
              v4,
              v5,
              v6,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v7
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentOverrideFormType",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v8,
                  v9,
                  v10
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v11
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v11
              },
              v12,
              v13,
              v14,
              v15,
              v16,
              v17,
              v18,
              v19,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v20,
                  v21,
                  v22,
                  v23,
                  v24
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v11
              }
            ]
          },
          v25,
          v26,
          v27,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v28
            ]
          },
          v29,
          v30,
          v31,
          v32,
          v33
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OverridePolicyQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentOverride",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentOverrideType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canComment",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subscribedToComments",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "usersNotificationComment",
                "storageKey": null,
                "args": null,
                "concreteType": "UserCommentNotificationType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOn",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v34
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "usersNotificationCommentOff",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserType",
                    "plural": true,
                    "selections": v34
                  }
                ]
              },
              v4,
              v5,
              v6,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "epAssociationDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "EpAssociationDocumentType",
                "plural": true,
                "selections": v35
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v35
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "editForm",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentOverrideFormType",
            "plural": false,
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "UserType",
                "plural": false,
                "selections": [
                  v3,
                  v8,
                  v9,
                  v10,
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": true,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": false,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "flowTemplateChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalWorkflowType",
                "plural": true,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "blocChoices",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": true,
                "selections": v36
              },
              v12,
              v13,
              v14,
              v15,
              v16,
              v17,
              v18,
              v19,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "onesourceDocuments",
                "storageKey": null,
                "args": null,
                "concreteType": "OneSourceDocumentType",
                "plural": true,
                "selections": [
                  v20,
                  v21,
                  v22,
                  v23,
                  v24,
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tagForm",
            "storageKey": null,
            "args": null,
            "concreteType": "TagFormType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v36
              }
            ]
          },
          v25,
          v26,
          v27,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenantsToRedirect",
            "storageKey": null,
            "args": null,
            "concreteType": "TenantType",
            "plural": true,
            "selections": [
              v4,
              v28,
              v2
            ]
          },
          v29,
          v30,
          v31,
          v32,
          v33
        ]
      }
    ]
  }
};
})();
node.text = "query OverridePolicyQuery(\n  $documentPk: Int!\n) {\n  documentOverride(pk: $documentPk) {\n    document {\n      ...commentForm_document\n      id\n      pk\n      name\n      status\n      actions(isEditPage: false) {\n        id\n        pk\n        actionType\n        actionDate\n        comment\n        canEdit\n        isExternal\n        user {\n          id\n          userDisplay(userDisplayType: FORWARD)\n        }\n      }\n      epAssociationDocuments {\n        pk\n        id\n      }\n      systemDocumentTemplate {\n        pk\n        id\n      }\n    }\n    editForm {\n      name\n      author {\n        pk\n        firstName\n        lastName\n        title\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      categoryChoices {\n        pk\n        name\n        id\n      }\n      flowTemplate {\n        pk\n        name\n        id\n      }\n      flowTemplateChoices {\n        pk\n        name\n        id\n      }\n      bloc {\n        pk\n        name\n        id\n      }\n      blocChoices {\n        pk\n        name\n        id\n      }\n      html\n      activeLifespan\n      expirationDate\n      isAForm\n      restricted\n      legacyEffectiveDate\n      approvalDate\n      regulations\n      onesourceDocuments {\n        oneSourceDocumentId\n        catalogNumber\n        manufacturerName\n        viewUrl\n        revisionInformation\n        id\n      }\n    }\n    tagForm {\n      tags {\n        pk\n        name\n        id\n      }\n    }\n    scheduledEffectiveDateForm {\n      effectiveDate\n      effectiveDateTimedelta\n      effectiveDateAlgorithm\n      originationDate\n    }\n    preimportRevisionForm {\n      revisionDates\n    }\n    error {\n      statusCode\n      message\n    }\n    tenantsToRedirect {\n      name\n      url\n      id\n    }\n    rtlSupport\n    newCkeditor\n    ckeditor5\n    redirectUrl\n    policyActions\n  }\n}\n\nfragment commentForm_document on DocumentType {\n  id\n  pk\n  canComment\n  subscribedToComments\n  usersNotificationComment {\n    usersNotificationCommentOn {\n      pk\n      firstName\n      lastName\n      id\n    }\n    usersNotificationCommentOff {\n      pk\n      firstName\n      lastName\n      id\n    }\n  }\n}\n";
(node/*: any*/).hash = '9a6422c64b69c251aa4b4af4b435682b';
module.exports = node;
